module.exports = __webpack_public_path__ + "static/img/shopmonks.d7a0e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopmonks.png
// module id = 7yz3
// module chunks = 1